module.exports = __webpack_public_path__ + "static/media/comment1_3.eede97da.png";